import { SyncId } from 'app/modules/settings/domain/valueObject/SyncId';
import { SyncStatus } from 'app/modules/settings/domain/valueObject/SyncStatus';

export class ProductSyncStatus {

    private readonly _name: SyncId;
    private readonly _status: SyncStatus;
    private readonly _startedAt: Date | null;
    private readonly _finishedAt: Date | null;
    private readonly _pendingCount: number;

    public constructor(
        name: SyncId,
        status: SyncStatus,
        startedAt: Date | null,
        finishedAt: Date | null,
        pendingCount: number,
    ) {
        this._name = name;
        this._status = status;
        this._startedAt = startedAt;
        this._finishedAt = finishedAt;
        this._pendingCount = pendingCount;
    }

    public get name(): SyncId {
        return this._name;
    }

    public get status(): SyncStatus {
        return this._status;
    }

    public get startedAt(): Date | null {
        return this._startedAt;
    }

    public get finishedAt(): Date | null {
        return this._finishedAt;
    }

    public get pendingCount(): number {
        return this._pendingCount;
    }

}
